export default "__VITE_ASSET__996b973b__"